import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const CompareSlider = ({ before, after, beforeLabel, afterLabel, className = "bg-slate-100", pixelate = true, testId = "compare-slider" }) => {
  const [pos, setPos] = useState(50);
  const box = useRef(null);
  const move = (clientX) => {
    const r = box.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };
  return (
    <div
      ref={box}
      data-testid={testId}
      className={`relative w-full select-none overflow-hidden rounded-xl ${className}`}
      onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
      onMouseDown={(e) => move(e.clientX)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
    >
      <img src={after} alt={afterLabel} className="block max-h-[620px] w-full object-contain" draggable={false} />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={beforeLabel} className="h-full w-full object-contain" style={pixelate ? { imageRendering: "pixelated" } : undefined} draggable={false} />
      </div>
      <div className="absolute inset-y-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(15,23,42,0.2)]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 grid h-10 w-10 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white shadow-lg">
          <MoveHorizontal className="h-4 w-4 text-slate-900" />
        </div>
      </div>
      <span className="absolute left-3 top-3 rounded-full bg-slate-900/80 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-white">{beforeLabel}</span>
      <span className="absolute right-3 top-3 rounded-full bg-[#00A3E0] px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-white">{afterLabel}</span>
    </div>
  );
};
